/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";

import HeaderContainer from "./HeaderContainer";
import Footer from "./Footer";

function render(Component, id, props) {
  hydrate(<Component {...props} />, document.getElementById(id));
}
render(HeaderContainer, "app-header", window.reactProps);
render(Footer, "app-footer", window.reactProps);
